import { categoryLabels, categoryIcons } from '@App/pages/MobilityPlan/mobility-plan.constants';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { Icon, Tooltip } from '@nazka/nazka.mapframe.components';

import './mobility-plan-content.styl';

const HIDDEN_CATEGORIES = ['updatedAt', 'updatedBy', 'verified', 'employeeInformation'];

function MobilityPlanContent({ mobilityOffer }) {
  if (!mobilityOffer) {
    return null;
  }

  return (
    <div className="mobility-plan-content">
      {Object.keys(mobilityOffer).map((category) => {
        if (HIDDEN_CATEGORIES.includes(category)) {
          return null;
        }

        const categoryValues = mobilityOffer[category];

        return (
          <div className="mobility-plan-content__item" key={category}>
            <h4 className="mobility-plan-content__item__title">
              {categoryIcons[category] && (
                <Icon
                  icon={categoryIcons[category]}
                  size="18px"
                  className="mobility-plan-content__item__title__icon"
                />
              )}
              {categoryLabels[category] || category}
            </h4>
            <ul className="mobility-plan-content__item__list">
              {categoryValues.map((value) => {
                return (
                  <li className="mobility-plan-content__item__list__item" key={value.name}>
                    <div className="mobility-plan-content__item__list__item__label">
                      {value.label}
                      {value.helpText && (
                        <Tooltip
                          id={`${value.label}-id`}
                          clickable
                          tooltip={(
                            <div className="mobility-plan-content__item__list__item__label__tooltip">
                              {value.helpText}
                            </div>
                          )}
                        >
                          <Icon
                            icon={faCircleInfo}
                            size="12px"
                            className="mobility-plan-content__item__list__item__label__tooltip__icon"
                            rootElProps={{ 'data-tooltip-id': `${value.label}-id` }}
                          />
                        </Tooltip>
                      )}
                    </div>
                    {value.subFields && Object.keys(value.subFields).map((subField) => {
                      return (
                        <ul>
                          <li>
                            {value.subFields[subField].label}
                            {value.subFields[subField].helpText && (
                              <Tooltip
                                id={`${value.subFields[subField].label}-id`}
                                clickable
                                tooltip={(
                                  <div className="mobility-plan-content__item__list__item__label__tooltip">
                                    {value.subFields[subField].helpText}
                                  </div>
                                )}
                              >
                                <Icon
                                  icon={faCircleInfo}
                                  size="12px"
                                  className="mobility-plan-content__item__list__item__label__tooltip__icon"
                                  rootElProps={{ 'data-tooltip-id': `${value.subFields[subField].label}-id` }}
                                />
                              </Tooltip>
                            )}
                          </li>
                        </ul>
                      );
                    })}
                  </li>
                );
              })}
            </ul>
          </div>
        )
      })}
    </div>
  );
}

export default MobilityPlanContent;